






















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import IView from "./IView";
import { RouteConfig } from "vue-router";
import { AddUserRoute } from "../router";

@Component
export default class UserManagement extends Vue implements IView {
    @Prop({ required: true })
    title!: string;

    get addRoute(): RouteConfig {
        return AddUserRoute;
    }
}
